<template>
    <div class="zebra-crossing-detail">
        <el-form :model="detail">
            <div class="zebra-item_tit">实施方案 </div>
                <el-card v-html="detail&&detail.implementPlan">{{detail.implementPlan}}
                    <!--<el-row>-->
                        <!--<el-col :span="24">-->
                            <!--<el-form-item >-->
                                <!--<ueditor :description.sync="detail&&detail.implementPlan" @getUeContent_imp="getUeContent_imp"></ueditor>-->
                            <!--</el-form-item>-->
                        <!--</el-col>-->
                    <!--</el-row>-->
                </el-card>

        </el-form>
    </div>
</template>

<script>
    import ueditor from "../../../components/ueditor.vue"
    export default {
        props:{
            detail:Object,
        },
        data() {
            return {

            }
        },
        created() {

        },
        methods: {
            getUeContent_imp(val){
                this.detail.implementPlan=val;
            },
        },
        components:{
            ueditor
        }
    }
</script>

<style scoped>

</style>
